import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router'
import { Html5Qrcode } from 'html5-qrcode'
import { COURSES } from '../data'
import { Button, Card } from '../components/ui'
import { Camera } from 'lucide-react'

export default function ScanCourse() {
  const navigate = useNavigate()
  const [scanning, setScanning] = useState(false)
  const [error, setError] = useState('')
  const scannerRef = useRef(null)

  useEffect(() => {
    return () => {
      scannerRef.current?.stop().catch(console.error)
    }
  }, [])

  const startScan = async () => {
    try {
      setError('')
      const scanner = new Html5Qrcode('qr-reader')
      scannerRef.current = scanner
      await scanner.start(
        { facingMode: 'environment' },
        { fps: 10, qrbox: { width: 250, height: 250 } },
        (decoded) => {
          const course = COURSES.find((c) => decoded.includes(c.id))
          if (course) {
            scanner.stop()
            navigate(`/course/${course.id}`)
          } else {
            setError('QR code not recognized. Please try again.')
          }
        },
        () => {}
      )
      setScanning(true)
    } catch (err) {
      setError('Unable to access camera. Please check permissions.')
      console.error(err)
    }
  }

  const stopScan = () => {
    if (scannerRef.current) {
      scannerRef.current.stop()
      setScanning(false)
    }
  }

  return (
    <div className="min-h-screen flex flex-col p-4">
      <div className="flex-1 flex flex-col items-center justify-center space-y-4">
        <Card className="w-full max-w-md p-6 bg-card">
          <div className="space-y-4">
            {scanning ? (
              <>
                <div id="qr-reader" className="w-full rounded-lg overflow-hidden" />
                <Button onClick={stopScan} variant="destructive" className="w-full" size="lg">
                  Stop Scanning
                </Button>
              </>
            ) : (
              <>
                <div className="w-full aspect-square bg-muted rounded-lg flex items-center justify-center">
                  <Camera className="h-16 w-16 text-muted-foreground" />
                </div>
                <Button onClick={startScan} className="w-full" size="lg">
                  <Camera className="mr-2 h-5 w-5" />
                  Start Camera
                </Button>
              </>
            )}

            {error && (
              <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-800 text-sm">
                {error}
              </div>
            )}

            <div className="text-center text-sm text-muted-foreground">
              Position the QR code within the frame
            </div>
          </div>
        </Card>

        <div className="text-center w-full max-w-md">
          <p className="text-muted-foreground mb-3">Don't have a QR code?</p>
          <div className="space-y-2">
            {COURSES.map((course) => (
              <Button
                key={course.id}
                variant="outline"
                className="w-full bg-card"
                onClick={() => navigate(`/course/${course.id}`)}
              >
                {course.name}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}